import React, {Fragment} from 'react';
import {FeedbackMovementsTable} from './FeedbackMovementsTable';

const FeedbackMovementsRoute = () => {
    return (
        <Fragment>
            <h1 className="mb-5">Feedback movements</h1>
            <FeedbackMovementsTable/>
        </Fragment>
    );
};

export {
    FeedbackMovementsRoute
};
